import React from 'react'
import cx from 'classnames'
import Frame, { FrameContextConsumer } from 'react-frame-component'
import NoSSR from 'react-no-ssr'

// Chakra UI uses Emotion for generating styles
// https://stackoverflow.com/questions/59098769/how-to-render-a-react-component-styled-with-emotion-in-an-iframe-in-gatsby-site
// https://codesandbox.io/s/scopeprovider-and-frameprovider-3t74v?file=/src/frame-provider.js
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'
import weakMemoize from '@emotion/weak-memoize'

let memoizedCreateCacheWithContainer = weakMemoize(container => {
  let newCache = createCache({ key: 'kiosk-widget', container })
  return newCache
})
const styles = `
  .widgetAppFrame {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    backgroundColor: #fff;
    borderRadius: 4px;
  }
  .widgetAppFrameActiveFullSize {
    borderRadius: 0;
  }
`

const WidgetFrame = ({ children, isActiveAndFullSize, ...props }) => {
  const appIframeClassName = cx({
    ['widgetAppFrame']: true,
    ['widgetAppFrameActiveFullSize']: isActiveAndFullSize,
  })
  const toastContainer = document.getElementById('chakra-toast-portal')

  // TODO: See if this is needed at all. This is from MUI not from Chakra UI, so it might not even do anything.
  // NoSsr fixes a strange concurrency issue with iframe and quick React mount/unmount
  return (
    <NoSSR>
      <style>{styles}</style>
      <Frame
        width='100%'
        allowFullScreen
        src='about:blank'
        scrolling='no'
        frameBorder={0}
        className={appIframeClassName}
        {...props}
      >
        <FrameContextConsumer>
          {({ document, window }) => {
            const rootContainer = document.getElementById('kiosk-container')
            console.log(rootContainer, 'root')
            // rootContainer.parentNode.insert(toastContainer, rootContainer);
            console.log(toastContainer, 'toast')
            return (
              <CacheProvider value={memoizedCreateCacheWithContainer(document.head)}>
                {React.cloneElement(children, {
                  // Pass iframe's document
                  frameDocument: document,
                  // Pass iframe's window
                  frameWindow: window,
                })}
              </CacheProvider>
            )
          }}
        </FrameContextConsumer>
      </Frame>
    </NoSSR>
  )
}

export default WidgetFrame
